import { useEffect } from "react";

export enum ExtensionMessageType {
  BREADCRUMB_CLICK,
  BREADCRUMB_SET,
  THEME
}

export type Breadcrumb = Record<"label" | "value", string>;

export interface BaseExtensionMessageData {
  type: ExtensionMessageType;
}

export interface BreadcrumbClickMessage extends BaseExtensionMessageData {
  breadcrumb: string;
}

export interface BreadcrumbChangeMessage extends BaseExtensionMessageData {
  breadcrumbs: Breadcrumb[];
}

export interface ThemeChangeMessage extends BaseExtensionMessageData {
  theme: "dark" | "light";
}

export interface ExtensionMessageEvent<T extends BaseExtensionMessageData> {
  data: T;
}

export function sendMessageToExtension<T extends BaseExtensionMessageData>(
  message: T,
  targetOrigin: string
) {
  window.parent.postMessage(message, targetOrigin);
}

export function useExtensionMessage<T extends BaseExtensionMessageData>(
  handle: (message: ExtensionMessageEvent<T>) => void
) {
  useEffect(() => {
    const listener: EventListener = event =>
      handle((event as unknown) as ExtensionMessageEvent<T>);
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [handle]);
}
